import { Box } from '@chakra-ui/react'
import { createContext, PropsWithChildren, useContext, useMemo, useRef } from 'react'
import { useResizeObserver } from '../../../hooks'

export interface FormWidthContextData {
  width: number
  mobileLayout: boolean
}
const FormWidthContext = createContext<FormWidthContextData>({ width: 0, mobileLayout: false })

export const FormWidthProvider = ({ children }: PropsWithChildren) => {
  const ref = useRef<HTMLDivElement>(null)
  const { width } = useResizeObserver(ref, 'border')
  const mobileLayout = useMemo(() => width < 700, [width])
  return (
    <FormWidthContext.Provider value={{ width, mobileLayout }}>
      <Box
        position="absolute"
        left={0}
        top={0}
        height="1px"
        pointerEvents="none"
        w="100%"
        ref={ref}
      />
      {children}
    </FormWidthContext.Provider>
  )
}

export const useFormWidth = () => useContext(FormWidthContext)
